import { render } from "./ShippingDeleteDialog.vue?vue&type=template&id=7dd63c6e"
import script from "./ShippingDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ShippingDeleteDialog.vue?vue&type=script&lang=js"

import "./ShippingDeleteDialog.vue?vue&type=style&index=0&id=7dd63c6e&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__